import { makeRoute } from "@/lib/makeRoute";
export const Route = makeRoute("/references", "fr", "references");
